module.exports = __webpack_public_path__ + "media/img/corporate/logos/ey-23b3c3de37dd22f816b759dd9e243729.svg";